import styles from './WholesalerTabs.module.scss';

const WholesalerTabs = ({ tabs, activeTab, setActiveTab, type = 'borderless' }) => (
  <div className={styles.container}>
    {tabs?.map((tab) => (
      <div
        key={tab}
        className={
          `${styles.tab} ${type === 'bottom-bordered' ? styles['bottom-bordered'] : styles['borderless']} ` +
          (activeTab === tab ? styles.active : '')
        }
        onClick={() => setActiveTab(tab)}
      >
        {tab}
      </div>
    ))}
  </div>
);

export default WholesalerTabs;